// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b2710c01","239":"e9cb49f0","453":"f8541e3b","732":"368a9caa"}[chunkId] + ".chunk.js";
};